/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ApiApi } from './services/api-api';
import { AuthApi } from './services/auth-api';
import { OauthApi } from './services/oauth-api';
import { Oauth2Api } from './services/oauth-2-api';
import { UserApi } from './services/user-api';
import { FeatureFlagApi } from './services/feature-flag-api';
import { ThemeApi } from './services/theme-api';
import { PodcastApi } from './services/podcast-api';
import { EpisodeApi } from './services/episode-api';
import { PublicEpisodeApi } from './services/public-episode-api';
import { ReviewApi } from './services/review-api';
import { WebsiteEpisodeApi } from './services/website-episode-api';
import { WebsiteReviewApi } from './services/website-review-api';
import { WebsitePodcastApi } from './services/website-podcast-api';
import { PodcastEpisodeApi } from './services/podcast-episode-api';
import { PodcastSegmentApi } from './services/podcast-segment-api';
import { WebsitePublicPodcastApi } from './services/website-public-podcast-api';
import { WebsiteApi } from './services/website-api';
import { WebsitePublicApi } from './services/website-public-api';
import { MediaApi } from './services/media-api';
import { PodcastAppleApi } from './services/podcast-apple-api';
import { PageApi } from './services/page-api';
import { PostApi } from './services/post-api';
import { AnalyticsApi } from './services/analytics-api';
import { WebsiteUserApi } from './services/website-user-api';
import { WebsitePublicUserApi } from './services/website-public-user-api';
import { WebsiteMembershipApi } from './services/website-membership-api';
import { WebsitePublicMembershipApi } from './services/website-public-membership-api';
import { WebsiteContentApi } from './services/website-content-api';
import { WebsiteDesignerApi } from './services/website-designer-api';
import { CommentApi } from './services/comment-api';
import { PublicCommentApi } from './services/public-comment-api';
import { WebsiteSettingsApi } from './services/website-settings-api';
import { WebsiteProductApi } from './services/website-product-api';
import { WebsitePublicProductApi } from './services/website-public-product-api';
import { WebsiteOrderApi } from './services/website-order-api';
import { WebsitePublicOrderApi } from './services/website-public-order-api';
import { WebsiteTaxonomyApi } from './services/website-taxonomy-api';
import { WebsitePublicTaxonomyApi } from './services/website-public-taxonomy-api';
import { WebsiteMessagesApi } from './services/website-messages-api';
import { WebsiteMessagesPublicApi } from './services/website-messages-public-api';
import { PublicationEmailApi } from './services/publication-email-api';
import { AdminApi } from './services/admin-api';
import { ReferralApi } from './services/referral-api';
import { MembershipApi } from './services/membership-api';
import { MembershipPlanApi } from './services/membership-plan-api';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApiApi,
    AuthApi,
    OauthApi,
    Oauth2Api,
    UserApi,
    FeatureFlagApi,
    ThemeApi,
    PodcastApi,
    EpisodeApi,
    PublicEpisodeApi,
    ReviewApi,
    WebsiteEpisodeApi,
    WebsiteReviewApi,
    WebsitePodcastApi,
    PodcastEpisodeApi,
    PodcastSegmentApi,
    WebsitePublicPodcastApi,
    WebsiteApi,
    WebsitePublicApi,
    MediaApi,
    PodcastAppleApi,
    PageApi,
    PostApi,
    AnalyticsApi,
    WebsiteUserApi,
    WebsitePublicUserApi,
    WebsiteMembershipApi,
    WebsitePublicMembershipApi,
    WebsiteContentApi,
    WebsiteDesignerApi,
    CommentApi,
    PublicCommentApi,
    WebsiteSettingsApi,
    WebsiteProductApi,
    WebsitePublicProductApi,
    WebsiteOrderApi,
    WebsitePublicOrderApi,
    WebsiteTaxonomyApi,
    WebsitePublicTaxonomyApi,
    WebsiteMessagesApi,
    WebsiteMessagesPublicApi,
    PublicationEmailApi,
    AdminApi,
    ReferralApi,
    MembershipApi,
    MembershipPlanApi,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
